__turbopack_context__.v({
  "isOpen": "p2-tvq_isOpen",
  "popover": "p2-tvq_popover",
  "underlay": "p2-tvq_underlay",
});
